import React from "react";
import "./InfoBanner.scss";
import { SVG, Button } from "shared";
import { SVG_ENUM } from "enums";
import { useUpdateSettings } from "hooks/settings";

interface InfoBannerProps {
  className?: string;
}

const InfoBanner: React.FC<InfoBannerProps> = ({ className = "" }) => {
  const { mutateAsync: updateSettings } = useUpdateSettings();

  const handleHideBanner = async () => {
    await updateSettings({
      name: "hide-successor-info-banner",
      valueBoolean: true,
    });
  };

  return (
    <div
      className={`info-banner successor-page__info-banner ${className || ""}`}
    >
      <div className="info-banner__left">
        <div className="info-banner__icon">
          <SVG type={SVG_ENUM.INFO} />
        </div>
      </div>
      <div className="info-banner__middle">
        <div className="info-banner__heading">
          Sukcesja – zabezpieczenie informacji na przyszłość
        </div>
        <div className="info-banner__paragraph">
          <p>
            W tej zakładce mogą Państwo bezpiecznie przechowywać istotne
            informacje oraz dokumenty, które – zgodnie z wolą – zostaną
            udostępnione po śmierci właściciela konta. Dostęp do tych danych
            zostanie przyznany wyłącznie na podstawie aktu zgonu, dostarczonego
            do Reliance przez uprawnioną osobę.
          </p>
          Zakładka umożliwia:
          <ul>
            <li>
              dodawanie dokumentów (np. testamentów, aktów własności, notatek
              prywatnych, zdjęć),
            </li>
            <li>
              decydowanie, czy dane mogą być widoczne dla pracowników Reliance,
            </li>
            <li>
              zlecenie poinformowania wskazanej osoby o procedurze dostępu do
              tych danych po Państwa śmierci (usługa dodatkowa),
            </li>
            <li>
              zarządzanie listą osób, którym przekazano instrukcje – z
              możliwością edycji i usuwania kontaktów.
            </li>
          </ul>
          <p>
            Dodanie pierwszego sukcesora wiąże się z jednorazową opłatą w
            wysokości <span>199 zł.</span> Za każdą kolejną wskazaną osobę
            obowiązuje opłata <span>99 zł</span>.
          </p>
        </div>
        <div className="info-banner__badge">
          <p>
            Prosimy nie umieszczać w tej sekcji poufnych danych,{" "}
            <span>
              takich jak: kody dostępu, hasła, lokalizacja sejfów lub szczegóły
              dotyczące przechowywania majątku!
            </span>
          </p>
        </div>
        <Button
          label="Ukryj"
          svg={SVG_ENUM.CLOSE_CIRCLE_GRAY}
          size="small"
          onClick={handleHideBanner}
          className="button--stroke button--rounded info-banner__button"
        />
      </div>

      <div className="info-banner__right">
        {className !== "" ? (
          <img
            className="info-banner__image"
            src={require("assets/images/man_climbing_stairs_heaven_mobile.webp")}
            alt=""
          />
        ) : (
          <img
            className="info-banner__image"
            src={require("assets/images/man_climbing_stairs_heaven_1.webp")}
            alt=""
          />
        )}

        <div className="info-banner__hide">
          <div onClick={handleHideBanner}>
            Ukryj <SVG type={SVG_ENUM.CLOSE_CIRCLE_GRAY} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoBanner;
